import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function ConditionsSection() {
  const conditions = ['Back & Neck Pain', 'Sciatica / Nerve Irritation', 'Arthritis & Joint Stiffness', 'Plantar Fasciitis / Heel Pain', 'Tendonitis & Overuse Injuries', 'Bursitis', 'Carpal Tunnel / Repetitive Strain', 'Muscle Strains & Sprains', 'Sports Injury Recovery', 'Shoulder, Hip & Knee Pain'];
  return <section className="py-20 md:py-24 bg-brand-gray-light" data-id="element-29">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-14" data-id="element-31">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-5 leading-tight" data-id="element-32">
            What Can Laser Therapy Help Support?
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-33">
            Patients commonly ask about laser therapy for a variety of acute and
            chronic concerns.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-34">
          {conditions.map((condition, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.04
        }} className="bg-white p-5 rounded-xl shadow-sm border-2 border-gray-200 hover:border-brand-teal/40 hover:shadow-md transition-all duration-300 flex items-center gap-4" data-id="element-35">
              <div className="w-10 h-10 bg-brand-teal/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-36">
                <CheckCircle2Icon className="w-5 h-5 text-brand-teal" data-id="element-37" />
              </div>
              <div data-id="element-38">
                <h3 className="font-black text-brand-navy text-base leading-tight" data-id="element-39">
                  {condition}
                </h3>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-40">
                  Commonly asked about
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center max-w-2xl mx-auto" data-id="element-41">
          <p className="text-sm md:text-base text-gray-600 italic bg-white py-3 px-6 rounded-full shadow-sm border border-gray-200 inline-block" data-id="element-42">
            A consultation determines whether laser therapy may be appropriate
            for your situation.
          </p>
        </motion.div>
      </div>
    </section>;
}